import CryptoJS from 'crypto-js';

const STORAGE_KEY = 'kaarya_user';
const SECRET_KEY = 'kaaryaalaya_v2_client_key';

const fromUrlSafe = (str) => str.replace(/-/g, '+').replace(/_/g, '/');

const decryptStored = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw || typeof raw !== 'string') return null;
    const parts = raw.split('://');
    const cipherUrlSafe = parts.length === 2 ? parts[1] : raw;
    const cipher = fromUrlSafe(cipherUrlSafe);
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    const json = bytes.toString(CryptoJS.enc.Utf8);
    if (!json) return null;
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
};

const AuthService = {
  getApiKey() {
    const data = decryptStored();
    return data?.apiKey || null;
  },
  getUser() {
    return decryptStored();
  },
  clear() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  },
};

export default AuthService;
